// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7140) return "static/chunks/7140-4ecfeed8a1ba3da1.js";
	if (chunkId === 6695) return "static/chunks/6695-83ef012d573d0542.js";
	if (chunkId === 5969) return "static/chunks/5969-662da17d4b3b3e7b.js";
	if (chunkId === 9111) return "static/chunks/9111-6ec4ff6bfd6e706f.js";
	if (chunkId === 512) return "static/chunks/512-e21227b91105cd2d.js";
	if (chunkId === 5411) return "static/chunks/5411-43ceba1cde81b016.js";
	if (chunkId === 8401) return "static/chunks/8401-ced60b3a97ebab96.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"528":"8b8e963733596163","2137":"48b181c7cad1f118","2743":"1afb490e7ff9990e","4000":"b90933b61e7da066","5959":"8b3fe2618b240472","6147":"c4f5d4e11ec33a28","6231":"3528ffbbfde7c82c","8955":"98a9a5b698a7d131"}[chunkId] + ".js";
};